import { registerAxiosClients } from '@dni-api-client/http/axios/registerAxiosClients'
import { clients } from './clients'

registerAxiosClients({
  clients,
})
